import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UsersSelfPrimaryCurrencyEffect } from './users-self-primary-currency.effect';
import { usersSelfBackend } from './users-self.backend';
import { usersSelfReducer } from './users-self.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('usersSelf', usersSelfReducer),
    BackendModule.forFeature('usersSelf', usersSelfBackend),
    EffectsModule.forFeature([UsersSelfPrimaryCurrencyEffect]),
  ],
})
export class DatastoreUsersSelfModule {}
